module.exports = __webpack_public_path__ + "media/promo/panasonic/images/recipes/rec-3-min-918512bee1fa2932236935bb0f7fce55.jpg";